<button class="btn"
        ng-class="{ active }"
        title="Previsão do tempo">
  <i ng-class="iconClass()"></i>
</button>
